module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"VideoPlayerUpNextContent":{"episode":"Episode","next":"Up Next","season":"Season"}},"es":{"VideoPlayerUpNextContent":{"episode":"Episodio","next":"A continuación","season":"Temporada"}},"pt":{"VideoPlayerUpNextContent":{"episode":"Episódio","next":"A seguir","season":"Temporada"}}}')
  delete Component.options._Ctor
}
